import API from '@sesame/web-api';

import { ICustomer } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';

const customerList: ICustomer[] = [];
const customerMap = new Map<number, string>()
let loading = false;

function wait(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const getCustomerCacheList = async (authToken: string): Promise<ICustomer[]> => {

  if (customerList.length == 0 && !loading) {
    loading = true;
    const response = await API.get(authToken, 'api/v1/customer')
      .catch((err) => {
        if (err.status === 404) {
          Alert(AlertTypes.ERROR, 'Customers Not Found');
          return;
        }
        Alert(AlertTypes.ERROR, 'Customers: ' + err.message);
      });
    const custList = response.data as ICustomer[];
    customerList.push(...custList);
    loading = false;
  } else if (loading) {
    await wait(500);
    return getCustomerCacheList(authToken);
  }
  return customerList;
}

export const getCustomerCacheMap = async (authToken: string): Promise<Map<number, string>> => {
  if (!customerMap.size) {
    const custList = await (getCustomerCacheList(authToken));
    custList.map(c => customerMap.set(c.customerId, c.name));
  }
  return customerMap;
}
